import { Component } from '@angular/core';
import { COMMON_IMPORTS } from '../../common-imports';

@Component({
  selector: 'app-references',
  standalone: true,
  imports: [...COMMON_IMPORTS],
  templateUrl: './references.component.html',
  styleUrl: './references.component.css',
})
export class ReferencesComponent {
  public referencesData = {
    western: {
      title: 'Western Data & Graphs',
      references: [
        {
          text: "McCullough SJ, O'Donoghue L, Saunders KJ. Six Year Refractive Change among White Children and Young Adults: Evidence for Significant Increase in Myopia among White UK Children. PLoS One. 2016;11(1):e0146332.",
        },
        {
          text: 'Leighton RE, Breslin KM, Richardson P, Doyle L, McCullough SJ, Saunders KJ. Relative peripheral hyperopia leads to greater short-term axial length growth in White children with myopia. Ophthalmic Physiol Opt. 2023;43(5):985-996.',
        },
        {
          text: 'Logan NS, Shah P, Rudnicka AR, Gilmartin B, Owen CG. Childhood ethnic differences in ametropia and ocular biometry: the Aston Eye Study. Ophthalmic Physiol Opt. 2011;31(5):550-558.',
        },
      ],
    },
    eastern: {
      title: 'Eastern Data & Graphs',
      references: [
        {
          text: 'Chen Y, Zhang J, Morgan IG, He M. Identifying Children at Risk of High Myopia Using Population Centile Curves of Refraction. PLoS One. 2016;11(12):e0167642.',
        },
        {
          text: 'Sanz Diez, P., Yang, LH., Lu, MX. et al. LMS parameters, percentile, and Z-score growth curves for axial length in Chinese schoolchildren in Wuhan. Sci Rep 12, 4850 (2022).',
        },
      ],
    },
    progression: {
      title: 'Progression data',
      references: [
        {
          text: 'Naduvilath T, He X, Saunders K, Demir P, Leighton R, McCullough S, et al. Regional/ethnic differences in ocular axial elongation and refractive error progression in myopic and non-myopic children. Ophthalmic Physiol Opt. 2025; 45: 135-151.',
        },
        {
          text: 'Brennan NA, Shamp W, Maynes E, Cheng X, Bullimore MA. Influence of age and race on axial elongation in myopic children: A systematic review and meta-regression. Optom VisSci. 2024;101(8):497-507.',
        },
      ],
    },
  };
}
